import { onBeforeUnmount, onMounted, useBlokkli } from "#imports";
export default function(cb) {
  const { commands } = useBlokkli();
  onMounted(() => {
    commands.add(cb);
  });
  onBeforeUnmount(() => {
    commands.remove(cb);
  });
}
